/* Wolf Bros – swipe through product images on product cards (collections, home, search).
   For "color cards" (card link has ?variant=), only that color's images are shown. */
(function () {
  if (window.__wbCardSlider) return;
  window.__wbCardSlider = true;

  const COLOR_RE = /colou?r|لون/i;
  const MAX_IMAGES = 10;
  const cache = {};

  const css = `
.media.wb-cs-on > img{opacity:0 !important;}
.wb-cs{position:absolute;inset:0;z-index:3;}
.wb-cs__track{display:flex;width:100%;height:100%;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch;cursor:pointer;overscroll-behavior-x:contain;}
.wb-cs__track::-webkit-scrollbar{display:none;}
.wb-cs__track img{flex:0 0 100%;width:100%;height:100%;object-fit:cover;scroll-snap-align:start;scroll-snap-stop:always;user-select:none;-webkit-user-drag:none;}
.wb-cs__btn{position:absolute;top:50%;transform:translateY(-50%);width:30px;height:30px;padding:0;border:0;border-radius:50%;background:rgba(255,255,255,.9);color:#111;font-size:20px;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer;opacity:0;transition:opacity .2s;box-shadow:0 1px 4px rgba(0,0,0,.25);}
.wb-cs__btn--prev{left:8px;}
.wb-cs__btn--next{right:8px;}
.card-wrapper:hover .wb-cs__btn{opacity:1;}
@media (hover:none){.wb-cs__btn{display:none;}}
.wb-cs__dots{position:absolute;left:0;right:0;bottom:8px;display:flex;justify-content:center;gap:5px;pointer-events:none;}
.wb-cs__dots span{width:6px;height:6px;border-radius:50%;background:rgba(255,255,255,.55);box-shadow:0 0 2px rgba(0,0,0,.5);transition:background .2s,transform .2s;}
.wb-cs__dots span.is-active{background:#fff;transform:scale(1.25);}
`;

  function addStyle() {
    const s = document.createElement('style');
    s.id = 'wb-card-slider-style';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function getProduct(handle) {
    cache[handle] =
      cache[handle] ||
      fetch(`/products/${handle}.js`)
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null);
    return cache[handle];
  }

  function imagesFor(product, variantId) {
    const media = product.media || [];
    const images = media.filter((m) => m.media_type === 'image');
    if (!images.length) return [];
    let list = images;

    const names = product.options.map((o) => (typeof o === 'string' ? o : o.name));
    const idx = names.findIndex((n) => COLOR_RE.test(n));
    const variant = variantId && product.variants.find((v) => String(v.id) === String(variantId));
    if (idx >= 0 && variant) {
      const order = new Map(media.map((m, i) => [String(m.id), i]));
      const start = {};
      product.variants.forEach((v) => {
        const fm = v.featured_media;
        if (!fm || !order.has(String(fm.id))) return;
        const i = order.get(String(fm.id));
        const c = v.options[idx];
        if (!(c in start) || i < start[c]) start[c] = i;
      });
      const colors = Object.keys(start).sort((a, b) => start[a] - start[b]);
      const color = variant.options[idx];
      if (colors.length > 1 && color in start) {
        const owner = (i) => {
          let o = colors[0];
          for (const c of colors) if (start[c] <= i) o = c;
          return o;
        };
        const own = images.filter((m) => owner(order.get(String(m.id))) === color);
        if (own.length) list = own;
      }
    }
    return list.slice(0, MAX_IMAGES).map((m) => (m.preview_image && m.preview_image.src) || m.src);
  }

  function sized(src, w) {
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function build(card) {
    if (card.dataset.wbCs) return;
    card.dataset.wbCs = '1';
    const link = card.querySelector('a[href*="/products/"]');
    const media = card.querySelector('.card__media .media');
    if (!link || !media) return;
    const url = new URL(link.getAttribute('href'), location.origin);
    const handle = (url.pathname.split('/products/')[1] || '').split('/')[0];
    if (!handle) return;
    const variantId = url.searchParams.get('variant');

    getProduct(handle).then((product) => {
      if (!product) return;
      const srcs = imagesFor(product, variantId);
      if (srcs.length < 2) return;

      const wrap = document.createElement('div');
      wrap.className = 'wb-cs';
      const track = document.createElement('div');
      track.className = 'wb-cs__track';
      srcs.forEach((src, i) => {
        const img = document.createElement('img');
        img.src = sized(src, 600);
        img.srcset = `${sized(src, 360)} 360w, ${sized(src, 600)} 600w, ${sized(src, 900)} 900w`;
        img.sizes = '(min-width: 990px) 25vw, 50vw';
        img.loading = i === 0 ? 'eager' : 'lazy';
        img.alt = product.title;
        img.draggable = false;
        track.appendChild(img);
      });

      const dots = document.createElement('div');
      dots.className = 'wb-cs__dots';
      srcs.forEach((_, i) => {
        const d = document.createElement('span');
        if (i === 0) d.className = 'is-active';
        dots.appendChild(d);
      });

      const mkBtn = (cls, label, dir) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'wb-cs__btn ' + cls;
        b.setAttribute('aria-label', label);
        b.textContent = dir < 0 ? '‹' : '›';
        b.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const w = track.clientWidth;
          const i = Math.round(track.scrollLeft / w);
          const n = srcs.length;
          const next = (i + dir + n) % n;
          track.scrollTo({ left: next * w, behavior: 'smooth' });
        });
        return b;
      };

      let startX = 0;
      track.addEventListener('pointerdown', () => (startX = track.scrollLeft));
      track.addEventListener('click', (e) => {
        if (Math.abs(track.scrollLeft - startX) > 5) return;
        e.preventDefault();
        window.location.href = link.href;
      });

      let raf = 0;
      track.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
            Array.from(dots.children).forEach((d, k) => d.classList.toggle('is-active', k === i));
          });
        },
        { passive: true }
      );

      wrap.append(track, mkBtn('wb-cs__btn--prev', 'Previous image', -1), mkBtn('wb-cs__btn--next', 'Next image', 1), dots);
      media.appendChild(wrap);
      media.classList.add('wb-cs-on');
      // The card's full-size link overlay sits above the image; lift the image area over it
      // so swipes / arrow taps reach the slider (tapping the image still opens the product).
      const inner = media.closest('.card__inner');
      if (inner) {
        inner.style.zIndex = '2';
        inner.querySelectorAll(':scope > .card__content').forEach((cc) => (cc.style.pointerEvents = 'none'));
      }
    });
  }

  const io =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((en) => {
              if (en.isIntersecting) {
                io.unobserve(en.target);
                build(en.target);
              }
            });
          },
          { rootMargin: '300px 0px' }
        )
      : null;

  // Sort the size pills on product cards (XS, S, M, L, XL, 2XL ...).
  const SIZE_RANK = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', 'XXXL', '4XL', '5XL', '6XL'];
  function sortSizes(card) {
    card.querySelectorAll('.card__size-variants').forEach((box) => {
      const items = Array.from(box.children);
      const rank = (el) => {
        const i = SIZE_RANK.indexOf((el.textContent || '').trim().toUpperCase());
        return i < 0 ? 99 : i;
      };
      if (items.some((el) => rank(el) === 99)) return;
      items
        .map((el, i) => ({ el, r: rank(el), i }))
        .sort((a, b) => a.r - b.r || a.i - b.i)
        .forEach(({ el }) => box.appendChild(el));
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('.card-wrapper:not([data-wb-cs-seen])').forEach((card) => {
      card.setAttribute('data-wb-cs-seen', '1');
      try {
        sortSizes(card);
      } catch (e) {}
      if (io) io.observe(card);
      else build(card);
    });
  }

  function init() {
    addStyle();
    scan();
    new MutationObserver((muts) => {
      for (const m of muts) if (m.addedNodes.length) return scan();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
